import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import FounderInsight from '../../components/FounderInsight';
import { FaCheck, FaChartLine, FaMobileAlt, FaClock, FaLightbulb, FaSearch, FaComments, FaPencilRuler, FaCode, FaRocket, FaUsers, FaEuroSign, FaLock } from 'react-icons/fa';

const WebAutonomosPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: '/servicios/diseno-web-pymes', text: 'Páginas web baratas para pymes' },
    { url: '/servicios/diseno-web-empresas', text: 'Páginas web baratas para empresas' },
    { url: '/servicios/diseno-web-abogados', text: 'Páginas web baratas para abogados' },
    { url: '/servicios/diseno-web-inmobiliarias', text: 'Páginas web baratas para inmobiliarias' },
    { url: '/precios', text: 'Ver todos nuestros precios' },
    { url: '/proceso', text: 'Conoce nuestro proceso de trabajo' },
  ];
  
  // Lista de beneficios adaptados al buyer persona José
  const benefits = [
    {
      title: "Consigue clientes reales, sin complicaciones",
      description: "Entendemos que necesitas una web que genere negocio real, no solo que se vea bonita. Te explicamos todo en lenguaje claro."
    },
    {
      title: "Inversión segura y sin sorpresas",
      description: "Precios transparentes desde 200€ (pago único) y mantenimiento fijo de 20€/mes. Sin costes ocultos ni permanencia obligatoria."
    },
    {
      title: "Hecha para ti aunque no entiendas de tecnología",
      description: "Nos encargamos de todo el proceso técnico. Tú solo necesitas contarnos sobre tu negocio, nosotros hacemos el resto."
    },
    {
      title: "Disponible 24/7 para tus clientes",
      description: "Mientras tú atiendes tu negocio, tu web trabaja captando clientes a todas horas, incluso cuando estás durmiendo."
    },
    {
      title: "Lista en solo 7 días",
      description: "No esperes meses. Entendemos que necesitas resultados rápidos para empezar a recuperar tu inversión cuanto antes."
    },
    {
      title: "Soporte directo cuando lo necesites",
      description: "¿Dudas? Te respondemos por WhatsApp o llamada. Sin robots, sin tickets de soporte, sin departamentos intermedios."
    }
  ];
  
  // Características de las webs adaptadas a preocupaciones de José
  const features = [
    {
      icon: <FaUsers />,
      title: "Diseñada para atraer clientes reales",
      description: "Tu web no será solo bonita, estará diseñada para convertir visitas en contactos y ventas. Incluimos elementos de confianza que hacen que la gente se anime a contactarte."
    },
    {
      icon: <FaMobileAlt />,
      title: "Perfecta en móviles (donde más te buscan)",
      description: "El 80% de tus potenciales clientes te buscarán desde el móvil. Tu web se adaptará a cualquier pantalla, sin textos pequeños ni menús que no funcionan."
    },
    {
      icon: <FaClock />,
      title: "Carga rápida (menos abandonos)",
      description: "Las webs lentas pierden clientes. La tuya cargará en menos de 3 segundos, evitando que los visitantes se marchen antes de ver tus servicios."
    },
    {
      icon: <FaSearch />,
      title: "Posicionada para que te encuentren",
      description: "Incluimos optimización SEO básica para que cuando alguien busque tus servicios en Google, encuentre tu web y no la de tu competencia."
    },
    {
      icon: <FaEuroSign />,
      title: "Rentable desde el primer mes",
      description: "Con que consigas un solo cliente gracias a tu web, ya habrás recuperado la inversión. Te mostramos ejemplos de autónomos como tú que ya lo han logrado."
    },
    {
      icon: <FaLock />,
      title: "Segura y con todas las garantías",
      description: "Incluimos todos los textos legales necesarios (RGPD, cookies, aviso legal) y certificado de seguridad para que tu web cumpla con la normativa."
    }
  ];
  
  // Planes de precios con lenguaje claro y directo
  const plans = [
    {
      title: 'Web Básica',
      price: 200,
      period: 'pago único',
      description: 'Ideal para dar el primer paso online sin arriesgar mucho dinero.',
      features: [
        { text: 'Hasta 5 páginas (inicio, servicios, sobre ti, contacto...)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: false },
        { text: 'Sección de testimonios de clientes', included: false },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=autonomo-basica',
      maintenanceFee: '20€/mes obligatorio incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Profesional',
      price: 300,
      period: 'pago único',
      description: 'La más solicitada por autónomos. Equilibrio perfecto entre precio y funcionalidades para atraer más clientes.',
      features: [
        { text: 'Hasta 10 páginas (más secciones y servicios)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      isPopular: true,
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=autonomo-profesional',
      maintenanceFee: '20€/mes obligatorio incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Avanzada',
      price: 400,
      period: 'pago único',
      description: 'Para profesionales que necesitan destacar en un mercado competitivo con más funcionalidades y mejor posicionamiento.',
      features: [
        { text: 'Hasta 15 páginas (contenido extenso y detallado)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: true },
        { text: 'Ficha de Google My Business', included: true },
        { text: 'Email Corporativo 1GB', included: true },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=autonomo-avanzada',
      maintenanceFee: '20€/mes obligatorio incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso con lenguaje directo
  const processSteps = [
    {
      number: 1,
      title: "Consulta inicial gratuita",
      description: "Hablamos sobre tu negocio y necesidades sin compromiso. Te explicamos todo el proceso en lenguaje claro, resolvemos tus dudas y te mostramos ejemplos similares a lo que necesitas.",
      icon: <FaComments />
    },
    {
      number: 2,
      title: "Diseño y desarrollo",
      description: "Creamos tu web en 7 días. Te mantenemos informado del progreso y te consultamos las decisiones importantes. No usamos plantillas genéricas, tu web será única.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Entrega y formación",
      description: "Te enseñamos cómo funciona tu web y cómo sacarle el máximo partido. No te dejamos solo: te damos consejos para conseguir clientes y resolver cualquier duda que tengas.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa enfocada en preocupaciones del buyer persona
  const comparisonItems = [
    {
      label: "Precio final transparente y sin sorpresas",
      us: true,
      others: false
    },
    {
      label: "Webs que realmente generan clientes",
      us: true,
      others: false
    },
    {
      label: "Entrega en 7 días garantizada",
      us: true,
      others: false
    },
    {
      label: "Mantenimiento con precio fijo (sin subidas)",
      us: true,
      others: false
    },
    {
      label: "Consultas ilimitadas de soporte",
      us: true,
      others: false
    },
    {
      label: "Explicaciones en lenguaje sencillo",
      us: true,
      others: false
    }
  ];
  
  // Testimonio real (usar un ejemplo cercano al buyer persona)
  const testimonial = {
    text: "Tenía miedo de gastar dinero en una web que no me aportara nada. Me sorprendió lo fácil que fue todo el proceso y lo bien que se entendía todo. En el primer mes ya conseguí 3 clientes nuevos gracias a la web, así que la inversión está más que amortizada.",
    author: "Antonio García",
    position: "Electricista Autónomo",
    company: "Instalaciones Eléctricas García",
    avatar: "/servicios/testimonios/autonomo.webp"
  };
  
  // FAQs adaptadas a las dudas más comunes del buyer persona
  const faqs = [
    {
      question: "¿Realmente puedo conseguir clientes con una web barata?",
      answer: "Absolutamente. No confundas barato con baja calidad. Nuestras webs son económicas porque hemos optimizado nuestro proceso de creación, pero están diseñadas específicamente para generar clientes. Tenemos decenas de casos de éxito de autónomos que han recuperado su inversión en el primer mes.",
      category: "General"
    },
    {
      question: "¿Cómo sé que no me vais a cobrar más dinero después?",
      answer: "Trabajamos con total transparencia: pagas un precio único por la creación (desde 200€) y una cuota fija mensual de mantenimiento (20€/mes) que incluye hosting, dominio y soporte. No hay costes ocultos ni sorpresas. Si en algún momento necesitas funcionalidades extra, te informaremos del coste antes de hacer nada.",
      category: "Precios"
    },
    {
      question: "No entiendo nada de webs, ¿podré gestionar la mía?",
      answer: "Tranquilo, lo hemos diseñado todo pensando en personas sin conocimientos técnicos. Te entregaremos la web lista para usar y te enseñaremos lo básico que necesitas saber. Además, cualquier duda que tengas después, podrás contactarnos directamente por WhatsApp y te ayudaremos sin usar jerga técnica complicada.",
      category: "Proceso"
    },
    {
      question: "¿Qué pasa si no me gusta el resultado final?",
      answer: "Trabajamos con un proceso de aprobaciones: antes de avanzar a la siguiente fase, te mostramos el diseño para que lo apruebes. Si algo no te convence, lo modificamos. Además, ofrecemos garantía de satisfacción: si el resultado final no cumple con lo acordado, realizamos los cambios necesarios sin coste adicional.",
      category: "Garantías"
    },
    {
      question: "¿Por qué sois más baratos que otras agencias?",
      answer: "Nos especializamos exclusivamente en webs para pequeños negocios y autónomos, lo que nos permite optimizar procesos y reducir costes. No tenemos una oficina física cara (trabajamos en remoto) y no gastamos en publicidad costosa. Todo esto nos permite ofrecer precios justos sin sacrificar calidad.",
      category: "Precios"
    },
    {
      question: "¿Cuánto tardaré en ver resultados?",
      answer: "Depende de tu sector, pero la mayoría de nuestros clientes comienzan a recibir contactos en las primeras semanas. El posicionamiento orgánico en Google puede tardar entre 1-3 meses en mostrar resultados significativos, pero desde el primer día puedes compartir tu web con clientes potenciales y usarla en tus redes sociales para generar contactos.",
      category: "Resultados"
    }
  ];

  const founderMessage = "Como especialista en SEO, he visto a muchos autónomos perder oportunidades por no tener presencia digital o tenerla mal optimizada. Diseñamos Web a Bajo Coste pensando especialmente en profesionales independientes que necesitan empezar a captar clientes online sin grandes inversiones iniciales.";

  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para autonomo
      pageTitle="Página Web Barata para Autónomos | Desde 200€ con Todo Incluido"
      pageDescription="Crea tu página web barata y profesional para autónomos desde 200€. Diseño que atrae clientes, soporte por WhatsApp y resultados garantizados. ¡Sin conocimientos técnicos!"
      pageKeywords="página web barata, diseño web autonomos, web economica, pagina web autónomos, precio pagina web"
      canonicalUrl="https://webabajocoste.es/servicios/diseno-web-autonomos"
      
      // Hero con mensaje directo al buyer persona
      heroTitle="Crea tu página web profesional desde 200€ y empieza a conseguir clientes"
      heroSubtitle="Diseñamos páginas web baratas para autónomos que realmente generan negocio. Sin permanencia, sin letras pequeñas, y con todo incluido. ¡En solo 7 días tendrás tu web activa!"
      heroImage="/servicios/tipo-cliente/autonomos-hero.webp"
      badges={['Desde 200€ (pago único)', 'Mantenimiento 20€/mes', 'Lista en 7 días', 'Soporte por WhatsApp']}
      heroCTAText="Reservar consulta gratuita"
      heroCTALink="/reserva"
      
      // Integración completa
      pricingTitle="Planes para tu página web de autónomo"
      pricingSubtitle="Elige el plan que mejor se adapte a tu negocio. Todos incluyen soporte técnico y mantenimiento obligatorio por 20€/mes."
      plans={plans}
      
      featuresTitle="¿Qué hace que nuestras webs baratas sean diferentes?"
      features={features}
      
      // Componente FounderInsight insertado como contenido personalizado
      customContent={
        <FounderInsight 
          insightText={founderMessage}
          founderName="Jaime Vela"
          founderTitle="Co-fundador y Director de Marketing"
          avatarSrc="/sobre nosotros/foto-jaime.webp"
        />
      }
      
      processTitle="Así trabajamos contigo: fácil, rápido y sin complicaciones"
      processSteps={processSteps}
      
      comparisonTitle="¿Por qué los autónomos nos eligen frente a otras opciones?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      benefitsTitle="Ventajas de tener tu página web profesional"
      benefits={benefits}
      
      faqTitle="Preguntas frecuentes sobre nuestras webs para autónomos"
      faqCategories={["General", "Precios", "Proceso", "Garantías", "Resultados"]}
      faqs={faqs}
      
      ctaTitle="Da el paso que tu negocio necesita"
      ctaDescription="Sin riesgos, sin complicaciones técnicas, con resultados reales. Tu web profesional desde 200€."
      ctaButtonText="Reservar consulta gratuita"
      ctaButtonLink="/reserva"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default WebAutonomosPage; 

